import { observer } from 'mobx-react';
import { NotTranslated, T } from '../../../../../../Translations';
import FlashError from '../../../../../FlashMessage/FlashError';
import { SubmittingError } from '.././Types';

interface Props {
  state: SubmittingError;
}

function SubmittingErrorView({ state }: Props) {
  return (
    <FlashError>
      <T kind="Error submitting form." /> <NotTranslated text={state.error.kind} />
    </FlashError>
  );
}

export default observer(SubmittingErrorView);
